export default {
  wx_api: {
    that   : this,
    pre    : 'http://h5.infzm.com/api/sign?',
    test   : 'http://test.misaka.im/weixin/sign?url=',
    infzm  : `appName=nfzm&url=`,
    digital: 'appName=smgc&url=',
    cnpc   : 'appName=cnpc&url=',
    sign   : function (name) {
      return name === 'test' ? this.test : `${this.pre + this[name]}`
    },
  },
  debug : true,

  share_info: () => {
    return {
      title : '带参数分享测试',
      desc  : '测试描述',
      link  : window.location.href.split("#")[0].split("?")[0],
      imgUrl: document.getElementById('share-icon') !== null ?
        document.getElementById('share-icon').src : ''
    }
  },

  wxApi       : function () {
    return location.host !== 'h5.misaka.im' ? this.wx_api.sign('infzm') : this.wx_api.sign('test')
  },
  linkedmeKey : '7579053a99a1a35d279354ff97c81c2c',
}
